import { useState } from 'react'
import Image from 'next/image'
import { IMAGE_BLUR_URL } from '../../utils/constants'
import style from '../../styles/components/where-to-watch/where-to-watch'

const Platform = ({ platform: { url, name, logo, logoHover, backgroundColor, backgroundColorHover } }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <>
      <a href={url} className='platform-wrapper' target='_blank' rel='noreferrer'>
        <div
          className='platform'
          data-testid='platform'
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ backgroundColor: isHovered ? backgroundColorHover : backgroundColor }}
        >
          <Image
            src={isHovered ? logoHover?.url : logo?.url}
            width={logo?.width}
            height={logo?.height}
            alt={name}
            layout='responsive'
            placeholder='blur'
            blurDataURL={IMAGE_BLUR_URL}
          />
        </div>
        <div className='platform-name'>{name}</div>
      </a>
      <style jsx>{style}</style>
    </>
  )
}

export default Platform
